import React from 'react';
import { Blackcurrant, Orange, Strawberry, UpArrow } from '../icons/Icons';

const PageSix = (props) => {
  return (
    <div className="kids-quiz__page">

      <div id="email" className="kids-quiz__question">
        <label>And finally, what is your email address?</label>
        <input onChange={e => props.setEmail(e.target.value)} placeholder="Email address (optional)" value={props.email} />
        <div className="checkbox" onChange={() => props.setConsent(!props.consent)}>
          <input id="email" name="consent" className="checkbox__input" type="checkbox" value="email" />
          <label htmlFor="email" className="checkbox__label">I agree to receive personalised email communications from Nourished based on my answers in this quiz</label>
        </div>
      </div>

      <div className="next-page" onClick={() => props.nextPage('6')}>View results</div>
    </div>
  );
}

export default PageSix;